export default {_name:'field.mention',module:'Field',view:'Element/Field/Mention',options:{key:'mentions',disabledProp:'disabled'},children:[]}